import { defineStore } from "pinia";
import { ref } from "vue";
import demoRequestService from "@/services/super-admin/demoRequestService";
import { toast } from "@/utils/toast";

export const useDemoRequestStore = defineStore("demoRequest", () => {
  const loading = ref(false);
  const items = ref([]);
  const pagination = ref({
    current_page: 1,
    last_page: 1,
    per_page: 25,
    total: 0,
  });

  const filters = ref({
    status: "",
    q: "",
    from: "",
    to: "",
  });

  async function fetchDemoRequests({ page = 1 } = {}) {
    loading.value = true;

    try {
      const res = await demoRequestService.fetch({
        page,
        per_page: pagination.value.per_page,
        status: filters.value.status || undefined,
        q: filters.value.q || undefined,
        from: filters.value.from || undefined,
        to: filters.value.to || undefined,
      });

      const data = res.data || {};
      items.value = data.data || [];
      pagination.value = {
        current_page: data.current_page || 1,
        last_page: data.last_page || 1,
        per_page: data.per_page || 25,
        total: data.total || 0,
      };
    } catch (error) {
      toast(
        error?.response?.data?.message || "Failed to load demo requests.",
        "error"
      );
    } finally {
      loading.value = false;
    }
  }

  async function updateStatus(id, status, adminNotes = null) {
    const payload = { status };
    if (adminNotes !== null) {
      payload.admin_notes = adminNotes;
    }

    await demoRequestService.update(id, payload);
    await fetchDemoRequests({ page: pagination.value.current_page });
    toast("Demo request updated.", "success");
  }

  async function remove(id) {
    await demoRequestService.delete(id);
    await fetchDemoRequests({ page: pagination.value.current_page });
    toast("Demo request deleted.", "success");
  }

  return {
    loading,
    items,
    pagination,
    filters,
    fetchDemoRequests,
    updateStatus,
    remove,
  };
});
